import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { IconButton, Tooltip } from "@mui/material";

interface Props {
  onClick: () => void;
  hidden: boolean;
  disabled?: boolean;
}

const ChangeReportNameButton = ({ onClick, hidden, disabled }: Props) => {
  return (
    <Tooltip title="Rename Report" arrow disableInteractive>
      <IconButton onClick={onClick} sx={{ visibility: hidden ? "hidden" : "visible" }} disabled={disabled}>
        <DriveFileRenameOutlineOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ChangeReportNameButton;
